import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

export const MealContainer = styled.div`
  display: flex;
`
export const MealTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  p {
    margin: 0;
    font-weight: 400;
    &.bold {
      font-weight: bold;
    }
  }
`

export const MealContent = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  span {
    color: ${({ theme }) => theme.colors?.textColor};
    font-family: 'Manrope';
    font-size: 13px;
    font-style: normal;
    line-height: normal;
    margin: 0;

    @media (max-width: calc(${BREAKPOINT_SM})) {
      font-size: 14px;
    }
  }
`
